export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '影视导航',
      links: [
        { label: '电影', href: '#cards' },
        { label: '电视剧', href: '#cards' },
        { label: '综艺', href: '#cards' },
        { label: '动漫', href: '#cards' },
        { label: '纪录片', href: '#cards' },
      ],
    },
    {
      title: '快捷入口',
      links: [
        { label: '更新快讯', href: '#updates' },
        { label: '热度榜单', href: '#ranking' },
        { label: '专题索引', href: '#index' },
        { label: '常见问答', href: '#faq' },
        { label: '关于我们', href: '#about' },
      ],
    },
    {
      title: '服务支持',
      links: [
        { label: '联系投稿', href: '#contact' },
        { label: '平台特色', href: '#features' },
        { label: '移动观影', href: '#app' },
        { label: '精彩预告', href: '#media' },
        { label: '热门话题', href: '#topics' },
      ],
    },
  ];

  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto py-12 md:py-16">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <span className="font-heading text-xl font-bold text-white">90影院</span>
              <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
                90影院致力于为8090后影视爱好者提供高清、超清、4K、蓝光画质的电影、电视剧、综艺、动漫资源，免费在线观看，播放流畅不缓冲，全集持续更新。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="font-medium text-white text-sm mb-4">{group.title}</h4>
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800/30">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-400">
                &copy; {currentYear} 90影院 — 8090影院高清超清4K蓝光影视大全，免费在线观看
              </p>
              <div className="flex items-center gap-4">
                <span className="text-xs text-foreground-400">合作伙伴</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}